// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__6eRUL","errorLogs":"styles_errorLogs__3vNgU"};